import React from 'react';

const Pencil = ({ svgRef, title, ...props }) => (
  <svg xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 20 19" width="1em" height="1em" ref={svgRef} {...props}>
    <title>{title}</title>
    <defs>
      <path id="Pencil_a" d="M1166.66 201.28l-2.94-2.94-10.26 10.27-.46 3.39 3.4-.46zm3.04-3.04c.4-.4.4-1.05 0-1.45l-1.49-1.49c-.4-.4-1.05-.4-1.45 0l-2 2.01 2.93 2.94z" />
      <path id="Pencil_b" d="M1153 214v-1h20v1z" />
    </defs>
    <use fill="currentColor" xlinkHref="#Pencil_a" transform="translate(-1153 -195)" />
    <use fill="currentColor" xlinkHref="#Pencil_b" transform="translate(-1153 -195)" />
  </svg>
);

export default Pencil;



// WEBPACK FOOTER //
// ./src/common/icons/Pencil.js